$(document).ready(function(){

	//----- Hero Banner Slider Center -----
	var $center_banner_slider 	= $('.o-banner-slider--center'),
		$center_banner_slide 	= $('.o-banner-slider .o-banner-slider__slide');

	if ($center_banner_slide.length > 1) {
		$center_banner_slider.slick({
			dots: false,
			arrows: true,
			fade: true,
			autoplay: true,
  			autoplaySpeed: 5000,
			infinite: true,
			responsive: [
				{
			      	breakpoint: 639,
			      	settings: {
			        	dots: true,
						arrows: false,
			      	}
			    }
			]
		});
	}


	var $left_banner_slider 	= $('.o-banner-slider--left'),
		$left_banner_slide 		= $('.o-banner-slider--left .o-banner-slider__slide');

	if ($left_banner_slide.length > 1) {
		$left_banner_slider.slick({
			dots: true,
			arrows: false,
			fade: true,
			autoplay: true,
  			autoplaySpeed: 5000,
			infinite: true,
		});
	}

	var $right_banner_slider 	= $('.o-banner-slider--right'),
		$right_banner_slide 	= $('.o-banner-slider--right .o-banner-slider__slide');

	if ($right_banner_slide.length > 1) {
		$right_banner_slider.slick({
			dots: true,
			arrows: false,
			fade: true,
			autoplay: true,
  			autoplaySpeed: 5000,
			infinite: true,
		});
	}

	var $testimonial_slider		= $('.o-testimonial-slider'),
		$testimonial_slide 		= $('.o-testimonial-slider .o-testimonial-slider__slide');

	if ($testimonial_slide.length > 1) {
		$testimonial_slider.slick({
			dots: false,
			arrows: true,
			fade: true,
			autoplay: true,
  			autoplaySpeed: 10000,
			infinite: true,
			responsive: [
				{
			      	breakpoint: 639,
			      	settings: {
			        	dots: true,
						arrows: false,
			      	}
			    }
			]
		});
	}

	let $options_slider = $('.o-options-slider-wrapper .js-options-slider');

	if ($options_slider.length) {
		$options_slider.slick({
			arrows: true,
			prevArrow: $options_slider.siblings('.js-options-slider-nav').children('.js-options-slider-prev'),
			nextArrow: $options_slider.siblings('.js-options-slider-nav').children('.js-options-slider-next'),
			fade: false,
			autoplay: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplaySpeed: 4000,
			rows: 0,
		});
	}
});

let $home_learn_slider 	= $('.js-learn-slider');

if ($home_learn_slider.length) {
    $home_learn_slider.slick({
        arrows: true,
        dots: true,
        fade: true,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 4000,
        rows: 0
    });
}

let $banner_options_slider = $('.o-page-banner .js-options-slider');

if ($banner_options_slider.length) {
    $banner_options_slider.slick({
        arrows: true,
        prevArrow: $banner_options_slider.siblings('.js-options-slider-nav').children('.js-options-slider-prev'),
        nextArrow: $banner_options_slider.siblings('.js-options-slider-nav').children('.js-options-slider-next'),
        fade: false,
        autoplay: false,
        variableWidth: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplaySpeed: 4000,
        rows: 0,
		dots: true,
        responsive: [
            {
              breakpoint: 1049,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                variableWidth: false,
              }
            }
        ]
    });
}


